import { createSlice } from '@reduxjs/toolkit';
import { type ExternalUser } from 'types/user.types';

export interface ExternalUserState {
  externalUserList: ExternalUser[];
  error: string | null;
  loading: boolean;
}

const initialState: ExternalUserState = {
  externalUserList: [],
  error: null,
  loading: false,
};

export const externalUserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setExternalUserList(state, { payload }: { payload: ExternalUser[] }) {
      state.externalUserList = payload;
    },
    appendExternalUserList(state, { payload }: { payload: ExternalUser }) {
      state.externalUserList.push(payload);
    },
    updateExternalUserList(state, { payload }: { payload: ExternalUser }) {
      const index = state.externalUserList.findIndex(
        (user) => user.userId === payload.userId
      );

      if (index === -1) {
        return;
      }

      state.externalUserList[index] = payload;
    },
    updateExternalUserShowOnlyProductiveTrips(
      state,
      {
        payload,
      }: { payload: { userId: string; showOnlyProductiveTrips: boolean } }
    ) {
      const index = state.externalUserList.findIndex(
        (user) => user.userId === payload.userId
      );

      if (index !== -1) {
        state.externalUserList[index].showOnlyProductiveTrips =
          payload.showOnlyProductiveTrips;
      }
    },
    setExternalUserLoading(state, { payload }: { payload: boolean }) {
      state.loading = payload;
    },
  },
});

export const {
  setExternalUserList,
  appendExternalUserList,
  updateExternalUserList,
  updateExternalUserShowOnlyProductiveTrips,
  setExternalUserLoading,
} = externalUserSlice.actions;

export default externalUserSlice.reducer;
